import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const Status = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5829 6.5848C15.9448 6.22349 16.4443 6.00006 16.9961 6.00006C18.1007 6.00006 18.9961 6.89549 18.9961 8.00006C18.9961 8.55181 18.7727 9.05138 18.4114 9.41323C17.8201 8.17771 16.8184 7.17607 15.5829 6.5848ZM11.2532 6.25713C11.5079 5.41674 11.942 4.65435 12.511 4.01453C8.31859 4.26529 4.99609 7.74467 4.99609 12.0001C4.99609 16.4183 8.57782 20.0001 12.9961 20.0001C17.2515 20.0001 20.7309 16.6776 20.9816 12.4852C20.3418 13.0541 19.5794 13.4883 18.739 13.743C17.9923 16.2067 15.7036 18.0001 12.9961 18.0001C9.68239 18.0001 6.99609 15.3138 6.99609 12.0001C6.99609 9.29252 8.78947 7.00386 11.2532 6.25713Z"
      fill="currentColor"
    />
    <circle cx="16.9961" cy="8" r="4" fill="currentColor" />
  </SvgIcon>
);

export default Status;
